import { useCallback } from "react";
import { useParams } from "react-router-dom";

export const SUPPORTED_LOCALES = ["sv", "en"];
export const DEFAULT_LOCALE = "sv";

export function useLocalePath() {
  const { locale } = useParams();
  const activeLocale = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;

  const localePath = useCallback(
    (path) => {
      if (path.startsWith("/admin")) return path;
      const clean = path.startsWith("/") ? path : `/${path}`;
      return `/${activeLocale}${clean}`;
    },
    [activeLocale]
  );

  return { locale: activeLocale, localePath };
}
